export const PODCASTS = `
    query podcasts($event_id: Uint) {
		podcasts(event_id: $event_id) {
			id
			event_id
			name
			description
			media_src
			art_src
			hidden
			duration
			mime_type
			listens
			pinned
			groups {                             
				id    
				name               
			}   
			created_at
			updated_at
		}
	}
`;

export const PODCAST = `
	query podcast($id: Uint) {
		podcast(id: $id) {                                                              
			id                                                                            
			event_id                                                                      
			name                                 
			description     
			media_src       
			art_src                                                                       
			hidden                               
			duration                                                                      
			mime_type                            
			listens   
			pinned                                                                    
			groups {                             
				id    
				name               
			}                                                                                               
			created_at                                    
			updated_at           
		}                        
	} 
`;

export const PINNED_PODCASTS = `
    query pinnedPodcasts($event_id: Uint) {
        pinnedPodcasts(event_id: $event_id) {
            id
            event_id
            name
            description
            media_src
            art_src
            hidden
            duration
            mime_type
            listens
            pinned
            groups {                             
				id    
				name               
			}   
            created_at
            updated_at
        }
    }
`;
